
import React from 'react';

export const UploadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24" 
        strokeWidth={1.5} 
        stroke="currentColor" 
        {...props}
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12.75h3.75a3.375 3.375 0 003.375-3.375V9.028a2.25 2.25 0 00-2.25-2.25h-3.75M8.25 12h3.75m-3.75 3h3.75M3.375 19.5h12.75A2.25 2.25 0 0018.5 17.25V6.75A2.25 2.25 0 0015.75 4.5H5.625A2.25 2.25 0 003.375 6.75v10.5A2.25 2.25 0 005.625 19.5z" />
    </svg>
);
